import { useState } from "react"

export const OrderState = () => {
    const [results, setResults] = useState([]);
    const [showVoucherModal, setShowVoucherModal] = useState(false)
    const [voucherCode, setVoucherCode] = useState('')
    const [voucher, setVoucher] = useState('')
    const [cart, setCart] = useState([])

    return {
        cart: {data: cart, set: setCart},
        results: {data: results, set: setResults},
        showVoucherModal: {data: showVoucherModal, set: setShowVoucherModal},
        voucherCode: {data: voucherCode, set: setVoucherCode},
        voucher: {data: voucher, set: setVoucher},
    }
}